import script from "./ml-form.vue?vue&type=script&setup=true&lang=js"
export * from "./ml-form.vue?vue&type=script&setup=true&lang=js"

import "./ml-form.vue?vue&type=style&index=0&id=35702d88&lang=scss"

const __exports__ = script;

export default __exports__